import { render, staticRenderFns } from "./loading-planner.vue?vue&type=template&id=740dfe2e&scoped=true&"
var script = {}
import style0 from "./loading-planner.vue?vue&type=style&index=0&id=740dfe2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740dfe2e",
  null
  
)

export default component.exports